export default __webpack_public_path__ + "static/media/accountBox.939d4e94.svg";